import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { useAppSelector as useSelector } from "../hooks/redux";

const PublicRoute = ({
  children,
  path,
  ...rest
}: RouteProps): React.ReactElement => {
  const state = useSelector((s) => s.admin);
  console.log(state.type);
  if (state.email) {
    //return <Redirect to={`login/${hash}`} />;
    if (state.type === "dashboard") {
      return <Redirect to={`/dashboard`} />;
    }
    if (state.type === "material") {
      return <Redirect to={`/materialContract`} />;
    }
    if (state.type === "service") {
      return <Redirect to={`/serviceContract`} />;
    }
    if (state.type === "lasService") {
      return <Redirect to={`/lasServiceContract`} />;
    }
    if (state.type === "lasMaterial") {
      return <Redirect to={`/lasMaterialContract`} />;
    }
  }
  return (
    <Route path={path} {...rest}>
      {children}
    </Route>
  );
};

export default PublicRoute;
